import {NgModule} from "@angular/core";
import {callToActionModalComponent} from "./call-to-action-modal.component";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";

@NgModule({
  exports: [
    callToActionModalComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [callToActionModalComponent]
})
export class callToActionModalModule {
}
